import React, { useEffect } from "react";
import $ from "jquery";
import "../style/messageBox.css";

export default function MessageBox(props) {
  // let messageBoxTitle = document.querySelector(".messageBoxTitle");
  // let messageBoxText = document.querySelector(".messageBoxText");
  useEffect(() => {
    if (props.type == "startAddingNote") {
      $(".messageBox").hide();
      // messageBoxTitle.innerText = "Legger til ny note";
      $(".messageBoxTitle").text("Legger til ny note");
      // messageBoxText.innerText = "Vennligst vent. Dette kan ta litt tid.";
      $(".messageBoxText").text("Vennligst vent. Dette kan ta litt tid.");
      addBusyBody();
      $(".messageBox").fadeIn(500);
    } else if (props.type == "successAddingNote") {
      $(".messageBox").hide();
      // messageBoxTitle.innerText = "Note opprettet";
      $(".messageBoxTitle").text("Note opprettet");
      // messageBoxText.innerText = "Nå kan du jobbe videre";
      $(".messageBoxText").text("Nå kan du jobbe videre");
      removeBusyBody();
      $(".messageBox").fadeIn(500).delay(3000).fadeOut(1000);
      // messageBoxDiv.style.display = "block";
    } else if (props.type == "startDeletingNote") {
      $(".messageBox").hide();
      // messageBoxTitle.innerText = "Sletter note";
      $(".messageBoxTitle").text("Sletter note");
      // messageBoxText.innerText = "Vennligst vent. Dette kan ta litt tid.";
      $(".messageBoxText").text("Vennligst vent. Dette kan ta litt tid.");
      addBusyBody();
      $(".messageBox").fadeIn(500);
    } else if (props.type == "successDeletingNote") {
      $(".messageBox").hide();
      // messageBoxTitle.innerText = "Note slettet";
      $(".messageBoxTitle").text("Note slettet");
      // messageBoxText.innerText = "Nå kan du jobbe videre";
      $(".messageBoxText").text("Nå kan du jobbe videre");
      removeBusyBody();
      $(".messageBox").fadeIn(500).delay(3000).fadeOut(1000);
    } else if (props.type == "successPingToAuthor") {
      $(".messageBox").hide();
      // messageBoxTitle.innerText = "Vellykket!";
      $(".messageBoxTitle").text("Vellykket!");
      // messageBoxText.innerText = "Varselet ditt er sendt til forfatter.";
      $(".messageBoxText").text("Varselet ditt er sendt til forfatter.");
      $(".messageBox").fadeIn(500).delay(3000).fadeOut(1000);
    } else if (props.type == "successPingToContentReviewer") {
      $(".messageBox").hide();
      // messageBoxTitle.innerText = "Vellykket!";
      $(".messageBoxTitle").text("Vellykket!");
      // messageBoxText.innerText = "Varselet ditt er sendt til fagredaktør.";
      $(".messageBoxText").text("Varselet ditt er sendt til fagredaktør.");
      $(".messageBox").fadeIn(500).delay(3000).fadeOut(1000);
    } else if (props.type == "hideMessageBox") {
      removeBusyBody();
      $(".messageBox").hide();
    }
    // else if (props.type == "successfulApproval") {
    //   $(".messageBox").hide();
    //   $(".messageBoxTitle").text("vellykket godkjenning!");
    //   $(".messageBoxText").text("");
    //   $(".messageBox").fadeIn(500).delay(3000).fadeOut(1000);
    // }
  }, [props.type]);

  const addBusyBody = () => {
    let lovtekstDiv = document.querySelector("#lovtekst");
    if (lovtekstDiv) {
      const busyBodyStatus = lovtekstDiv.classList.contains("busyBody");
      if (!busyBodyStatus) {
        lovtekstDiv.classList.add("busyBody");
      }
    }
  };

  const removeBusyBody = () => {
    let lovtekstDiv = document.querySelector("#lovtekst");
    if (lovtekstDiv) {
      const busyBodyStatus = lovtekstDiv.classList.contains("busyBody");
      if (busyBodyStatus) {
        lovtekstDiv.classList.remove("busyBody");
      }
    }
  };

  return (
    <div className="messageBox">
      <h1 className="messageBoxTitle">Title</h1>
      <p className="messageBoxText">Message</p>
    </div>
  );
}
